module.exports = require("common-tags");